import React from "react";

export default function Section21() {
  const services = [
    {
      title: "Scalable Websites for Growing Brands",
      description: `OOur scalable websites and web applications are built to support your business at every stage. We focus on performance, flexibility, and seamless integrations so your digital platform can grow without limitations.`,
    },
    {
      title: "Design & Technical Excellence",
      description: `Texas businesses trust Mean3 website designers for user-friendly, high-performing platforms. We provide smart web design and robust development for workflows, automation, and integrations—helping Texas companies grow efficiently.`,
    },
  ];

  return (
    <div className="w-full Section11 bg-[#fff]">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">


        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#f5f5f5] text-[#373737]"} p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px]`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>

            </div>
          ))}

        </div>
      </div>
      
    </div>

  );
}
